export default (hotel) => ({
  ..._.omit(hotel, 'category'),
    hotelCategory: hotel.category,
});